<template>
  <el-drawer
    :visible.sync="drawerVisible"
    :title="isEdit ? '编辑组件化活动' : '新增组件化活动'"
    size="60%"
    :before-close="handleClose"
    custom-class="unit-event-drawer"
  >
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form :model="formData" :rules="rules" ref="unitEventForm" label-width="120px">
        <!-- 基本信息 -->
        <el-card class="form-section" header="基本信息">
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="formData.name" placeholder="请输入活动名称"></el-input>
          </el-form-item>
          
          <el-form-item label="活动描述" prop="eventDesc">
            <el-input v-model="formData.eventDesc" placeholder="请输入活动描述"></el-input>
          </el-form-item>
          
          <el-form-item label="活动URL" prop="url" v-if="isEdit">
            <el-input v-model="formData.url" placeholder="请输入活动链接URL"></el-input>
          </el-form-item>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="时区" prop="zoneOffset">
                <el-select v-model="formData.zoneOffset" filterable placeholder="请选择时区">
                  <el-option v-for="item in searchConst.zoneOffset" :key="item.value" 
                    :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="日期格式" prop="dateFormat">
                <el-select v-model="formData.dateFormat" filterable placeholder="请选择日期格式">
                  <el-option v-for="item in searchConst.dateFormat" :key="item.value" 
                    :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="开始时间" prop="startTime">
                <el-date-picker
                  v-model="formData.startTime"
                  type="datetime"
                  placeholder="选择开始时间"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker
                  v-model="formData.endTime"
                  type="datetime"
                  placeholder="选择结束时间"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        
        <!-- 页面配置信息 -->
        <el-card class="form-section" header="页面配置信息">
          <el-form-item label="活动头图">
            <div style="display: flex; align-items: center; gap: 10px;">
              <UploadSingleImg v-model="formData.pageInfo.headImg" :on-upload="uploadHeadImg" />
              <el-input v-model="formData.pageInfo.headImg" placeholder="请输入活动头图URL" style="flex: 1;"></el-input>
            </div>
          </el-form-item>
          
          <el-form-item label="活动头部背景图">
            <div style="display: flex; align-items: center; gap: 10px;">
              <UploadSingleImg v-model="formData.pageInfo.headBackgroundImg" :on-upload="uploadHeadBackgroundImg" />
              <el-input v-model="formData.pageInfo.headBackgroundImg" placeholder="请输入活动头部背景图URL" style="flex: 1;"></el-input>
            </div>
          </el-form-item>
        </el-card>
        
        <!-- 限制条件 -->
        <el-card class="form-section" header="限制条件">
          <el-form-item label="渠道列表">
            <el-select v-model="formData.channelSet" multiple filterable 
              placeholder="请选择渠道列表（为空则不限制）" style="width: 100%">
              <el-option v-for="item in searchConst.channelList" :key="item.value" 
                :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="国家列表">
            <el-select v-model="formData.countryCodeSet" multiple filterable 
              placeholder="请选择国家列表（为空则不限制）" style="width: 100%">
              <el-option v-for="item in searchConst.countryList" :key="item.countryCode" 
                :label="item.country" :value="item.countryCode">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="参与群体">
            <el-select v-model="formData.joinModeInfo.mode" filterable 
              placeholder="请选择参与群体" style="width: 100%">
              <el-option v-for="item in searchConst.joinMode" :key="item.value" 
                :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          
          <!-- 参与条件配置 -->
          <div v-if="formData.joinModeInfo.mode === 1" class="conditions-tabs">
            <el-form-item label="参与条件">
              <div v-for="(conditionObj, ind) in formData.joinModeInfo.conditions" :key="ind">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-select filterable v-model="conditionObj.relation" placeholder="逻辑关系">
                      <el-option v-for="item in searchConst.relation" :key="item.value" 
                        :label="item.name" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="6">
                    <el-select filterable v-model="conditionObj.mode" placeholder="条件类型" 
                      @change="() => { conditionObj.value = null }">
                      <el-option v-for="item in searchConst.conditionMode" :key="item.value" 
                        :label="item.name" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5">
                    <el-select filterable v-model="conditionObj.condition" placeholder="关系符">
                      <el-option v-for="(item, ind) in searchConst.condition" :key="ind" 
                        :label="item.name" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5">
                    <el-date-picker v-if="conditionObj.mode == 1" v-model="conditionObj.value" 
                      value-format="timestamp" type="datetime" :disabled="!formData.zoneOffset" 
                      placeholder="选择日期时间">
                    </el-date-picker>
                    <el-select v-else-if="conditionObj.mode == 3" v-model="conditionObj.value" placeholder="请选择">
                      <el-option label="男" value="1"></el-option>
                      <el-option label="女" value="2"></el-option>
                    </el-select>
                    <el-select v-else-if="conditionObj.mode == 2" v-model="conditionObj.value" placeholder="请选择">
                      <el-option label="用户" value="1"></el-option>
                      <el-option label="主播" value="2"></el-option>
                    </el-select>
                    <el-input v-else-if="conditionObj.mode == 4" v-model="conditionObj.value" 
                      placeholder="贵族是1~6"></el-input>
                    <el-input v-else-if="conditionObj.mode == 6" v-model="conditionObj.value" 
                      placeholder="用英文,分割"></el-input>
                    <el-select v-else-if="conditionObj.mode == 7" v-model="conditionObj.value" placeholder="请选择">
                      <el-option label="是" value="true"></el-option>
                      <el-option label="否" value="false"></el-option>
                    </el-select>
                    <el-input v-else v-model="conditionObj.value" placeholder="输入值"></el-input>
                  </el-col>
                  <el-col :span="2">
                    <div class="ico-box">
                      <i class="el-icon-delete-solid ico" @click="delConditions(ind)"></i>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="btn-flex">
                <el-button size="small" type="primary" plain @click="addConditions">新增条件</el-button>
              </div>
            </el-form-item>
          </div>
          
          <el-form-item label="禁止参与用户">
            <div class="not-join-user-config">
              <div class="user-count-display">
                <el-tag type="info" v-if="formData.notJoinRidSet && formData.notJoinRidSet.length > 0">
                  已配置 {{ formData.notJoinRidSet.length }} 个禁止参与用户
                </el-tag>
                <el-tag type="info" v-else>
                  暂无禁止参与用户
                </el-tag>
              </div>
              <el-button 
                type="primary" 
                size="small" 
                icon="el-icon-setting"
                @click="showNotJoinUserManager">
                管理禁止用户
              </el-button>
            </div>
          </el-form-item>
        </el-card>
        
        <!-- 成本配置 -->
        <el-card class="form-section" header="成本配置">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="成本限制类型">
                <el-select v-model="formData.costLimitDurationType" placeholder="请选择">
                  <el-option value="" label="活动期间"></el-option>
                  <el-option value="0" label="每天"></el-option>
                  <el-option value="5" label="每周"></el-option>
                  <el-option value="6" label="每月"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最大成本限制">
                <el-input-number v-model="formData.maxCostLimit" 
                  :min="0" placeholder="最大成本限制"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        
        <!-- 其他配置 -->
        <el-card class="form-section" header="其他配置">
          <el-form-item label="通知图片">
            <div style="display: flex; align-items: center; gap: 10px;">
              <UploadSingleImg v-model="formData.noticeImg" :on-upload="uploadNoticeImg" />
              <el-input v-model="formData.noticeImg" placeholder="请输入通知图片URL" style="flex: 1;"></el-input>
            </div>
          </el-form-item>
          
          <el-form-item label="奖励Keys">
            <div class="awards-keys-display">
              <div class="keys-info">
                <el-tag 
                  v-for="key in computedAwardsKeys" 
                  :key="key" 
                  size="small" 
                  style="margin-right: 8px; margin-bottom: 4px;">
                  {{ key }}
                </el-tag>
                <span v-if="computedAwardsKeys.length === 0" class="no-keys-text">
                  暂无奖励Key（将从组件配置中自动收集）
                </span>
              </div>
              <el-button 
                size="mini" 
                type="text" 
                @click="refreshAwardsKeys"
                style="margin-left: 8px;">
                <i class="el-icon-refresh"></i> 刷新
              </el-button>
            </div>
          </el-form-item>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="是否有效">
                <el-switch v-model="formData.valid" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开启灰度测试">
                <el-switch v-model="formData.enableTestGray" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        
        <!-- 组件配置 -->
        <el-card class="form-section" header="活动组件配置">
          <div class="unit-config-section">
            <div class="unit-header">
              <span>已配置组件</span>
              <el-button type="primary" size="small" @click="showUnitEditor">添加组件</el-button>
            </div>
            
            <div v-if="formData.units && formData.units.length > 0" class="unit-list">
              <div v-for="(unit, index) in formData.units" :key="index" class="unit-item">
                <div class="unit-info">
                  <div class="unit-title"> x
                    <span class="unit-type-tag" :style="{ backgroundColor: getUnitTypeColor(unit.unitType) }">{{ getUnitTypeName(unit.unitType) }}</span>
                    <span class="unit-id">#{{ unit.unitId }}</span>
                    <span class="unit-name">{{ unit.unitName }}</span>
                    <span class="unit-aka">{{ unit.unitAka }}</span>
                  </div>
                  <div class="unit-desc">{{ unit.unitDesc }}</div>
                </div>
                <div class="unit-actions">
                  <el-button size="mini" @click="editUnit(index)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="removeUnit(index)">删除</el-button>
                </div>
              </div>
            </div>
            
            <div v-else class="empty-units">
              <el-empty description="暂无组件配置" :image-size="60"></el-empty>
            </div>
          </div>
        </el-card>
        </el-form>
      </div>
      
      <div class="drawer-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </div>
    
    <!-- 组件编辑器 -->
    <UnitEditor v-model="unitEditorVisible" :unit-data="currentUnit" 
      @save="handleUnitSave" :is-edit="isEditingUnit" :all-units="formData.units"
      :activity-start-time="formData.startTime"
      :activity-end-time="formData.endTime"
      :activity-zone-offset="formData.zoneOffset">
    </UnitEditor>

    <!-- 禁止参与用户管理 -->
    <NotJoinUserManager 
      v-model="notJoinUserDialog.show" 
      :not-join-rid-set="formData.notJoinRidSet || []"
      @save="handleNotJoinUserSave">
    </NotJoinUserManager>
  </el-drawer>
</template>

<script>
import { getConstList } from '@/api/constRequest'
import { getChannelList, getCountryList } from '@/api/baseRequest'
import { createUnitEventReq, updateUnitEventReq } from '@/api/activityUnitRequest'
import UnitEditor from './UnitEditor.vue'
import NotJoinUserManager from './NotJoinUserManager.vue'
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg'
import { getUnitTypeName, getUnitTypeColor } from '@/utils/unitTypeConstants'

export default {
  name: 'UnitEventDrawer',
  components: {
    UnitEditor,
    NotJoinUserManager,
    UploadSingleImg
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      drawerVisible: false,
      unitEditorVisible: false,
      currentUnit: {},
      currentUnitIndex: -1,
      isEditingUnit: false,
      notJoinUserDialog: {
        show: false
      },
      searchConst: {
        zoneOffset: [],
        dateFormat: [],
        channelList: [],
        countryList: [],
        joinMode: [],
        relation: [],
        conditionMode: [],
        condition: []
      },
      formData: {
        name: '',
        eventDesc: '',
        url: '',  // 添加 URL 字段
        zoneOffset: '+05:30',
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        startTime: '',
        endTime: '',
        channelSet: [],
        countryCodeSet: [],
        notJoinRidSet: [],
        costLimitDurationType: '',
        maxCostLimit: 0,
        noticeImg: '',
        awardsKeys: [],  // 移除 awardsKeysStr，只保留 awardsKeys
        valid: 1,
        enableTestGray: 0,
        fuse: 0,
        fuseTime: '',
        units: [],
        pageInfo: {
          headImg: '',
          headBackgroundImg: ''
        },
        joinModeInfo: {
          mode: 0,
          conditions: [{
            mode: 0,
            relation: '',
            condition: '',
            value: ''
          }]
        }
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        eventDesc: [
          { required: true, message: '请输入活动描述', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    value(val) {
      this.drawerVisible = val
      if (val && this.isEdit && this.data) {
        this.initFormData()
      } else if (val && !this.isEdit) {
        this.resetFormData()
      }
    },
    drawerVisible(val) {
      this.$emit('input', val)
    },
    // 监听 data 变化，当导入数据时重新初始化
    data: {
      handler(newVal) {
        if (this.drawerVisible && newVal && Object.keys(newVal).length > 0) {
          if (this.isEdit) {
            this.initFormData()
          } else {
            // 新增模式下，如果有导入的数据，需要填充表单
            this.formData = { ...this.formData, ...newVal }
            this.normalizeFormData()
            this.formData.awardsKeys = this.collectAwardsKeysFromUnits(this.formData.units || [])
          }
        }
      },
      deep: true,
      immediate: false
    },
    // 监听参与群体模式变化
    'formData.joinModeInfo.mode': {
      handler(newVal) {
        // 当mode为0时，conditions必须为空数组
        if (newVal === 0) {
          this.formData.joinModeInfo.conditions = []
        } else if (newVal === 1 && this.formData.joinModeInfo.conditions.length === 0) {
          // 当mode为1且没有条件时，初始化一个默认条件
          this.formData.joinModeInfo.conditions = [{
            mode: 0,
            relation: '',
            condition: '',
            value: ''
          }]
        }
      },
      immediate: false
    }
  },
  computed: {
    // 计算自动收集的奖励keys
    computedAwardsKeys() {
      return this.collectAwardsKeysFromUnits(this.formData.units || [])
    }
  },
  methods: {
    getUnitTypeName(type) {
      return getUnitTypeName(type)
    },
    getUnitTypeColor(type) {
      return getUnitTypeColor(type)
    },
    showUnitEditor() {
      this.currentUnit = {}
      this.currentUnitIndex = -1
      this.isEditingUnit = false
      this.unitEditorVisible = true
    },
    editUnit(index) {
      this.currentUnit = { ...this.formData.units[index] }
      this.currentUnitIndex = index
      this.isEditingUnit = true
      this.unitEditorVisible = true
    },
    removeUnit(index) {
      this.$confirm('确定要删除这个组件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData.units.splice(index, 1)
      })
    },
    handleUnitSave(unitData) {
      if (this.isEditingUnit) {
        this.$set(this.formData.units, this.currentUnitIndex, unitData)
      } else {
        this.formData.units.push(unitData)
      }
      this.unitEditorVisible = false
    },

    // 从组件中收集奖励key
    collectAwardsKeysFromUnits(units) {
      const keysSet = new Set()
      
      units.forEach(unit => {
        // 从不同类型的组件中收集奖励key
        if (unit.awardPoolUnit && unit.awardPoolUnit.awardsKey) {
          keysSet.add(unit.awardPoolUnit.awardsKey)
        }
        
        if (unit.taskUnit) {
          if (unit.taskUnit.config && unit.taskUnit.config.awardsKey) {
            keysSet.add(unit.taskUnit.config.awardsKey)
          }
          if (unit.taskUnit.configs) {
            unit.taskUnit.configs.forEach(config => {
              if (config.awardsKey) {
                keysSet.add(config.awardsKey)
              }
            })
          }
        }
        
        if (unit.rankUnit && unit.rankUnit.rewardConfigs) {
          unit.rankUnit.rewardConfigs.forEach(reward => {
            if (reward.awardsKey) {
              keysSet.add(reward.awardsKey)
            }
            // 子榜单奖励Key
            if (reward.sonRankAwardsKey) {
              keysSet.add(reward.sonRankAwardsKey)
            }
          })
        }
        
        if (unit.stepPoolUnit) {
          if (unit.stepPoolUnit.sonPools) {
            unit.stepPoolUnit.sonPools.forEach(pool => {
              if (pool.awardsKey) {
                keysSet.add(pool.awardsKey)
              }
            })
          }
          if (unit.stepPoolUnit.stepRewards) {
            unit.stepPoolUnit.stepRewards.forEach(reward => {
              if (reward.awardsKey) {
                keysSet.add(reward.awardsKey)
              }
            })
          }
        }
        
        if (unit.shopUnit && unit.shopUnit.items) {
          unit.shopUnit.items.forEach(item => {
            if (item.awardsKey) {
              keysSet.add(item.awardsKey)
            }
          })
        }
        
        // 货币合成组件
        if (unit.currencyMergeUnit && unit.currencyMergeUnit.awardsKey) {
          keysSet.add(unit.currencyMergeUnit.awardsKey)
        }
        
        // 分享组件
        if (unit.shareUnit) {
          if (unit.shareUnit.shareAwardsKey) {
            keysSet.add(unit.shareUnit.shareAwardsKey)
          }
          if (unit.shareUnit.shareToAwardsKey) {
            keysSet.add(unit.shareUnit.shareToAwardsKey)
          }
        }
        
        // 刮刮乐组件
        if (unit.scratchCardUnit && unit.scratchCardUnit.mappingList) {
          unit.scratchCardUnit.mappingList.forEach(mapping => {
            if (mapping.awardsKey) {
              keysSet.add(mapping.awardsKey)
            }
          })
        }
      })
      
      return Array.from(keysSet).filter(key => key && key.trim())
    },

    // 刷新奖励keys
    refreshAwardsKeys() {
      // 更新formData中的awardsKeys
      this.formData.awardsKeys = this.computedAwardsKeys
      this.$message.success('奖励Keys已刷新')
    },

    normalizeFormData() {
      // 确保数组/对象结构存在，避免外部传入 null 时报错
      if (!Array.isArray(this.formData.units)) {
        this.formData.units = this.formData.units ? [].concat(this.formData.units) : []
      }

      if (!this.formData.pageInfo) {
        this.formData.pageInfo = {
          headImg: '',
          headBackgroundImg: ''
        }
      } else {
        if (this.formData.pageInfo.headImg === undefined || this.formData.pageInfo.headImg === null) {
          this.formData.pageInfo.headImg = ''
        }
        if (this.formData.pageInfo.headBackgroundImg === undefined || this.formData.pageInfo.headBackgroundImg === null) {
          this.formData.pageInfo.headBackgroundImg = ''
        }
      }

      if (!this.formData.joinModeInfo) {
        this.formData.joinModeInfo = {
          mode: 0,
          conditions: [{
            mode: 0,
            relation: '',
            condition: '',
            value: ''
          }]
        }
      } else if (!Array.isArray(this.formData.joinModeInfo.conditions)) {
        this.formData.joinModeInfo.conditions = []
      }

      if (!Array.isArray(this.formData.notJoinRidSet)) {
        this.formData.notJoinRidSet = []
      }
    },

    initFormData() {
      this.formData = { ...this.data }
      
      this.normalizeFormData()
      
      // 自动从组件中收集奖励keys
      this.formData.awardsKeys = this.collectAwardsKeysFromUnits(this.formData.units)
      
    },
    resetFormData() {
      this.formData = {
        name: '',
        eventDesc: '',
        url: '',  // 添加 URL 字段
        zoneOffset: '+05:30',
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        startTime: '',
        endTime: '',
        channelSet: [],
        countryCodeSet: [],
        notJoinRidSet: [],
        costLimitDurationType: '',
        maxCostLimit: 0,
        noticeImg: '',
        awardsKeys: [],  // 移除 awardsKeysStr，只保留 awardsKeys
        valid: 1,
        enableTestGray: 0,
        fuse: 0,
        fuseTime: '',
        units: [],
        pageInfo: {
          headImg: '',
          headBackgroundImg: ''
        },
        joinModeInfo: {
          mode: 0,
          conditions: [{
            mode: 0,
            relation: '',
            condition: '',
            value: ''
          }]
        }
      }
    },
    async handleClose() {
      await this.$editLock.unlock('resource_type_event_unit', this.formData.id)
      this.drawerVisible = false
    },
    handleSubmit() {
      this.$refs.unitEventForm.validate(async (valid) => {
        if (valid) {
          try {
            // 处理数据格式
            const submitData = { ...this.formData }
            
            // 自动从组件中收集奖励keys
            submitData.awardsKeys = this.collectAwardsKeysFromUnits(submitData.units || [])
            
            // 确保channelSet和countryCodeSet为数组
            if (!Array.isArray(submitData.channelSet)) {
              submitData.channelSet = []
            }
            if (!Array.isArray(submitData.countryCodeSet)) {
              submitData.countryCodeSet = []
            }
            
            // 确保joinModeInfo结构正确
            if (!submitData.joinModeInfo) {
              submitData.joinModeInfo = {
                mode: 0,
                conditions: []
              }
            }
            if (!Array.isArray(submitData.joinModeInfo.conditions)) {
              submitData.joinModeInfo.conditions = []
            }
            
            // 确保notJoinRidSet为整数数组以符合API要求
            if (Array.isArray(submitData.notJoinRidSet)) {
              submitData.notJoinRidSet = submitData.notJoinRidSet.map(rid => {
                const parsed = parseInt(rid)
                return isNaN(parsed) ? 0 : parsed
              }).filter(rid => rid > 0)
            } else {
              submitData.notJoinRidSet = []
            }
            
            // 确保pageInfo存在
            if (!submitData.pageInfo) {
              submitData.pageInfo = {
                headImg: '',
                headBackgroundImg: ''
              }
            } else {
              // 确保pageInfo中的字段存在
              if (submitData.pageInfo.headImg === undefined) {
                submitData.pageInfo.headImg = ''
              }
              if (submitData.pageInfo.headBackgroundImg === undefined) {
                submitData.pageInfo.headBackgroundImg = ''
              }
            }
            
            let res
            if (this.isEdit) {
              res = await updateUnitEventReq(submitData)
            } else {
              res = await createUnitEventReq(submitData)
            }
            
            if (res.code === 0) {
              this.$message.success(this.isEdit ? '修改成功' : '创建成功')
              await this.$editLock.unlock('resource_type_event_unit', this.formData.id)
              this.$emit('submit')
              this.handleClose()
            } else {
              this.$message.error(res.msg)
            }
          } catch (error) {
            this.$message.error('操作失败')
            console.error(error)
          }
        }
      })
    },
    
    // 删除条件
    delConditions(ind) {
      this.formData.joinModeInfo.conditions.splice(ind, 1)
    },
    
    // 新增条件
    addConditions() {
      this.formData.joinModeInfo.conditions.push({
        mode: 0,
        relation: '',
        condition: '',
        value: ''
      })
    },
    
    // 显示禁止用户管理对话框
    showNotJoinUserManager() {
      this.notJoinUserDialog.show = true
    },
    
    // 保存禁止参与用户
    handleNotJoinUserSave(ridList) {
      this.formData.notJoinRidSet = ridList
      this.$message.success('禁止参与用户配置已更新')
    },
    
    // 获取常量数据
    async getConstData() {
      try {
        const [
          timeZoneRes, 
          dateFormatRes, 
          joinModeRes, 
          relationRes, 
          conditionModeRes, 
          conditionRes
        ] = await Promise.all([
          getConstList('timeZone'),
          getConstList('dateFormat'),
          getConstList('joinMode'),
          getConstList('relation'),
          getConstList('conditionMode'),
          getConstList('condition')
        ])
        
        if (timeZoneRes.code === 0) this.searchConst.zoneOffset = timeZoneRes.data
        if (dateFormatRes.code === 0) this.searchConst.dateFormat = dateFormatRes.data
        if (joinModeRes.code === 0) this.searchConst.joinMode = joinModeRes.data
        if (relationRes.code === 0) this.searchConst.relation = relationRes.data
        if (conditionModeRes.code === 0) this.searchConst.conditionMode = conditionModeRes.data
        if (conditionRes.code === 0) this.searchConst.condition = conditionRes.data
        
        // 获取渠道和国家数据 (使用模拟数据或其他API)
        this.getChannelAndCountryData()
        
      } catch (error) {
        console.error('获取常量数据失败:', error)
      }
    },
    
    // 获取渠道和国家数据
    async getChannelAndCountryData() {
      try {
        const [channelData, countryData] = await Promise.all([
          getChannelList(),
          getCountryList()
        ])
        
        this.searchConst.channelList = channelData
        this.searchConst.countryList = countryData
      } catch (error) {
        console.error('获取渠道和国家数据失败:', error)
        // 如果获取失败，使用默认数据
        this.searchConst.channelList = [
          { value: 'cde', name: 'CDE' },
          { value: 'appstore_tikko', name: 'App Store Tikko' },
          { value: 'googleplay', name: 'Google Play' },
          { value: 'official', name: 'Official' }
        ]
        
        this.searchConst.countryList = [
          { countryCode: 'US', country: '美国' },
          { countryCode: 'IN', country: '印度' },
          { countryCode: 'ID', country: '印度尼西亚' },
          { countryCode: 'PH', country: '菲律宾' },
          { countryCode: 'TH', country: '泰国' },
          { countryCode: 'VN', country: '越南' }
        ]
      }
    },
    
    // 上传通知图片
    async uploadNoticeImg(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', 'notice_img/unit/event/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
    
    // 上传活动头图
    async uploadHeadImg(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', 'page_info/head_img/unit/event/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
    
    // 上传活动头部背景图
    async uploadHeadBackgroundImg(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', 'page_info/head_background/unit/event/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    }
  },
  async mounted() {
    await this.getConstData()
  }
}
</script>

<style scoped lang="scss">
/* 抽屉容器 */
::v-deep .unit-event-drawer {
  .el-drawer__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.drawer-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.drawer-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  
  /* 优化滚动条样式 */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
    
    &:hover {
      background: #a1a1a1;
    }
  }
}

.form-section {
  margin-bottom: 20px;
  
  .el-card__header {
    font-weight: bold;
    background-color: #f5f7fa;
  }
}

.conditions-tabs {
  .el-row {
    margin-bottom: 12px;
  }
  
  .ico-box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    
    .ico {
      font-size: 18px;
      color: #f56c6c;
      cursor: pointer;
      
      &:hover {
        color: #f78989;
      }
    }
  }
  
  .btn-flex {
    margin-top: 12px;
    text-align: left;
  }
}

.unit-config-section {
  .unit-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    
    span {
      font-weight: bold;
    }
  }
  
  .unit-list {
    .unit-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      margin-bottom: 8px;
      
      .unit-info {
        flex: 1;
        
        .unit-title {
          margin-bottom: 4px;
          
          .unit-type-tag {
            display: inline-block;
            padding: 2px 8px;
            background-color: #409eff;
            color: white;
            border-radius: 4px;
            font-size: 12px;
            margin-right: 8px;
          }
          
          .unit-id {
            color: #909399;
            font-size: 12px;
            margin-right: 8px;
            font-weight: normal;
          }
          
          .unit-name {
            font-weight: bold;
            margin-right: 8px;
          }
          
          .unit-aka {
            color: #909399;
          }
        }
        
        .unit-desc {
          color: #666;
          font-size: 12px;
        }
      }
      
      .unit-actions {
        margin-left: 16px;
      }
    }
  }
  
  .empty-units {
    text-align: center;
    padding: 20px;
  }
}

.drawer-footer {
  padding: 16px 20px;
  background-color: #fff;
  border-top: 1px solid #e4e7ed;
  text-align: right;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  
  .el-button {
    margin-left: 8px;
  }
}

// 奖励keys显示区域样式
.awards-keys-display {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fafafa;

  .keys-info {
    flex: 1;
    min-height: 32px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    
    .el-tag {
      font-family: 'Courier New', monospace;
      font-size: 12px;
    }
    
    .no-keys-text {
      color: #909399;
      font-style: italic;
      font-size: 13px;
    }
  }
}

// 禁止参与用户配置样式
.not-join-user-config {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fafafa;

  .user-count-display {
    flex: 1;
  }

  .el-button {
    margin-left: 10px;
  }
}
</style> 